import { Link } from 'gatsby-link'
import React, { Fragment } from 'react'

const DividerIcon = () => {
  return (
      <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.707031 10.0802L4.77814 6.00016L0.707031 1.92016L1.96036 0.66683L7.2937 6.00016L1.96036 11.3335L0.707031 10.0802Z" fill="#FB7347"/>
      </svg>
  )
}

function BreadcrumbWithMicroData({ crumbs, crumbSeparator, crumbLabel, getProps }) {
  const getCurrentPageCrumbLabel = (index, elementLabel) => {
    if (index === crumbs.length - 1) {
      return crumbLabel || elementLabel
    }

    return elementLabel
  }

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb__list" itemScope itemType="https://schema.org/BreadcrumbList">
        {crumbs.map((crumb, index) => (
          <Fragment key={crumb.pathname}>
            <li
              key={crumb.pathname}
              className="breadcrumb__list__item"
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              <Link
                className="breadcrumb__link"
                to={crumb.pathname}
                itemProp="item"
                getProps={getProps}
              >
                <span itemProp="name">{getCurrentPageCrumbLabel(index, crumb.crumbLabel)}</span>
              </Link>
              <meta itemProp="position" content={index + 1} />
            </li>
            {index + 1 < crumbs.length && (
              <span className="breadcrumb__separator"><DividerIcon/></span>
            )}
          </Fragment>
        ))}
      </ol>
    </nav>
  )
}

export default BreadcrumbWithMicroData
